module.exports = "<video\n  #video\n  id=\"my-video\"\n  class=\"video-js\"\n  controls\n  controlsList=\"nodownload\"\n  preload=\"none\"\n  data-setup=\"{}\"\n>\n  <source *ngIf=\"isMp4Source\" [src]=\"url\" type=\"video/mp4\" />\n  <source *ngIf=\"!isMp4Source\" [src]=\"url\" type=\"video/webm\" />\n</video>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/media-player/media-player.component.html
// module id = ./src/app/shared/components/media-player/media-player.component.html
// module chunks = main